import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    dsn: 'https://5fe748905d6b94ab023f2b061b1991ad@o4509117460119552.ingest.de.sentry.io/4509309204430928',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false
      }),
      Sentry.feedbackIntegration({
        colorScheme: 'system',
        isNameRequired: true,
        showBranding: false,
        triggerLabel: 'Report',
        formTitle: 'Feedback/Report a Bug',
        messagePlaceholder: 'Please enter feedback or a bug Report',
        submitButtonLabel: 'Submit Feedback',
        themeLight: {
          accentBackground: 'var(--color-primary)',
          successColor: 'var(--color-success)',
          errorColor: 'var(--color-error)'
        },
        themeDark: {
          accentBackground: 'var(--color-primary)',
          successColor: 'var(--color-success)',
          errorColor: 'var(--color-error)'
        }
      })
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

if (globalThis.window !== undefined) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    debug: false
  });
}
